module.exports = __webpack_public_path__ + "1793882494189/images/maestrocard.796fb62.png";